import { Record, List } from 'immutable';

// Conforms to Dropdown interface
export class DisplayRole extends Record({ name: null, id: null }) {}

export const TEACHER = new DisplayRole({ id: 'Teacher', name: 'Teacher' });
export const STUDENT = new DisplayRole({ id: 'Student', name: 'Student' });

export const DISPLAY_ROLES = List([
  TEACHER,
  STUDENT,
]);
